/**
 * File Utilities
 * URL conversion and file-related helpers
 */

/**
 * Converts API-relative URLs to full URLs using the backend base URL.
 * This is needed because image URLs like /api/download/public/{fileId}
 * are relative to the API server, not the frontend server.
 *
 * @param {string} url - The URL to convert (can be relative or absolute)
 * @returns {string|null} - The full URL or null if input is falsy
 */
export const getApiFileUrl = (url) => {
  if (!url) return null;

  // If it's already an absolute URL (http/https/blob), return as-is
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('blob:')) {
    return url;
  }

  // Get the API base URL from environment
  const apiBaseUrl = process.env.REACT_APP_URL || '';

  // If URL starts with /api/, strip that since REACT_APP_URL already includes /api/
  if (url.startsWith('/api/')) {
    const baseWithoutTrailingSlash = apiBaseUrl.replace(/\/$/, '');
    const pathWithoutApiPrefix = url.substring(4); // Remove '/api' prefix
    return baseWithoutTrailingSlash + pathWithoutApiPrefix;
  }

  // For other relative URLs, prepend the base URL (without /api/)
  const baseUrl = apiBaseUrl.replace(/\/api\/?$/, '');
  return baseUrl + url;
};

